import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { faCalendarWeek } from '@fortawesome/pro-solid-svg-icons';
import { html, css, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { svgWithJs, variables } from '../variables';

export interface SelectableLink {
  text?: string;
  url?: string;
  icon?: string;
  action: string;
  tooltip?: string;
}

@customElement('apt-selectable-message')
export class SelectableMessage extends LitElement {
  @property({ type: Object })
  firstLink = { text: '', url: '', action: '', icon: '', tooltip: '' };
  @property({ type: Object })
  secondLink = { text: '', url: '', action: '', icon: '', tooltip: '' };

  static override get styles() {
    return [
      variables,
      svgWithJs,
      css`
        :host {
          font-family: var(--font-family-sans-serif);
          font-style: normal;
          font-size: 1rem;
          color: var(--white);
        }

        .flex-container {
          display: flex;
          justify-content: center;
          background-color: var(--dark-blue);
          border: 1px solid var(--border);
        }

        p {
          margin-left: auto;
          cursor: pointer;
          text-decoration: underline;
        }

        p:last-of-type {
          padding-right: 20px;
        }
      `,
    ];
  }

  override render() {
    return html`<div class="flex-container">
      <p @click=${() => this.handleClick(this.firstLink)}>
        ${this.firstLink.text}
      </p>
      <p
        @click=${() => this.handleClick(this.secondLink)}
        title="${this.secondLink.tooltip}"
      >
        <span class="fa-solid ${this.secondLink.icon}"></span>
      </p>
    </div>`;
  }

  private handleClick(link: SelectableLink) {
    this.dispatchEvent(
      new CustomEvent('MessageLinkClicked', {
        detail: link,
      }),
    );
  }

  protected override firstUpdated(): void {
    library.add(faCalendarWeek);

    // @ts-ignore The dom.watch() TS definition indicates no parameters for this. However, when
    // you actually dig into the code, you see that it looks at the arguments after it gets into
    // the code and tries to pull some out if there aren't any (it even supplies an empty object
    // for options if you don't supply one yourself).
    //
    // Note: We have to wait for the first update for the shadow DOM to even be created.
    dom.watch({
      autoReplaceSvgRoot: this.shadowRoot,
      observeMutationsRoot: this.shadowRoot,
    });
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'apt-selectable-message': SelectableMessage;
  }
}
